import IsIos from '@/mixins/is-ios.js'
import formValidator from '@/mixins/form-validator.js'
import toastStore from '@/stores/toast-store.js'
import logo from '@/assets/images/collectomate-logo.png'
import { required, email } from 'vuelidate/lib/validators'
import axios from 'axios'
import sessionStore from '@/stores/session-store.js'
import { EventBus } from '../../../event-bus.js'
import RedirectToLockersOrDeliveries from '@/mixins/redirect-to-lockers-or-deliveries.js'
import { VueRecaptcha } from 'vue-recaptcha'

export default {
  name: 'SignInWithCode',
  mixins: [IsIos, formValidator, RedirectToLockersOrDeliveries],
  data: function () {
    return {
      code: '',

      logo: logo,
      blocker: false,
      errors: {},
      submitted: false,
      showCodeInput: false,
    }
  },
  methods: {
    signInWithCode() {
      this.submitted = true
      this.validateForm()

      if (Object.keys(this.errors).length > 0) {
        toastStore.commit('error', {
          message: this.$t('messages.validationErrorFillFields'),
        })
      } else {
        this.blocker = true
        axios({
          method: 'post',
          url: 'auth/sign_in_with_code',
          data: {
            code: this.code,
          },
        })
          .then(response => {
            if (response.status == 200) {
              sessionStore.commit('setData', response.data.token)
              sessionStore.commit('setUser', response.data.user)

              // REPEATED CODE...
              if (response.data.user.isAdmin || response.data.user.hasAnyAdminMembers) {
                this.$store.commit(
                  'setShowMyLockersOnly',
                  response.data.user.isAdmin || response.data.user.hasAnyAdminMembers,
                )
              }
              setTimeout(this.redirectToLockersOrDeliveries)
            }
            // IT'S GETTING CROWDED HERE
            EventBus.$emit(`showOnboardingAndModalsWhenLogin`)
            EventBus.$emit(`showAddToHomeScreenPrompt`)
            EventBus.$emit(`prefetchLockers`)
            this.setSkipLocationCheckTrue()
          })
          .catch(error => {
            this.blocker = false
            const errorMessage = error.response.data.errors
              ? Object.values(error.response.data.errors).join(', ')
              : this.$t('messages.error')

            if (error.response.status == 403) {
              toastStore.commit('error', { message: 'Too many failed attempts' })
            } else {
              toastStore.commit('error', { message: errorMessage })
            }
          })
          .finally(() => {
            this.blocker = false
          })
      }
    },
    setSkipLocationCheckTrue() {
      window.localStorage.setItem('skipLocalizationCheck', true)
    },
    verifyMethod(response) {
      if (response) {
        this.showCodeInput = true
      }
    },
  },
  validations() {
    if (this.submitted) {
      return {
        user: {
          email: {
            required,
            email,
          },
        },
      }
    } else {
      return {}
    }
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
    VueRecaptcha,
  },
}
